const app = {};

let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

app.parsePrice = price => parseInt((price).replace(/[.,]/g, ''));

app.currency = price => {
    price = (price / 100).toLocaleString('nl-NL', {
        style: 'currency',
        currency: 'eur',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    price = price.replace(/\u00a0/g, '').replace('€', '');

    return price;
};

app.image = (url, w = null, h = null) => `${url}${w ? `&width=${w}` : ''}${h ? `&height=${h}` : ''}`;

app.lockBody = (keepScrollbar = true) => {
    const scrollTop = window.scrollY;

    document.body.classList.add('locked');

    if(scrollTop === 0) {
        document.body.classList.add('locked--on-top');
    }

    if(keepScrollbar && document.documentElement.scrollHeight > document.documentElement.clientHeight) {
        document.body.style.overflowY = 'scroll';
    }

    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.setProperty('margin-top', `-${scrollTop}px`, 'important');

    document.body.dataset.scrollTop = scrollTop;
};

app.unlockBody = () => {
    const scrollTop = Number(document.body.dataset.scrollTop || 0);

    document.body.classList.remove('locked', 'locked--on-top');

    document.body.style.removeProperty('position');
    document.body.style.removeProperty('width');
    document.body.style.removeProperty('overflow-y');
    document.body.style.removeProperty('margin-top');

    document.body.removeAttribute('data-scroll-top');

    // html { scroll-behavior: smooth } zou anders deze scroll animeren (zichtbaar na modals/nav)
    const docEl = document.documentElement;
    const previousScrollBehavior = docEl.style.scrollBehavior;
    docEl.style.scrollBehavior = 'auto';
    window.scrollTo(0, scrollTop);
    docEl.style.scrollBehavior = previousScrollBehavior;
};

app.viewport = {
    sizes: ['xs', 'sm', 'md', 'lg', 'xl'],
    is: () => window.getComputedStyle(document.body, ':after').content.replace(/"/g, ''),
    isEqualOrGreaterThan: size => app.viewport.getIndex(app.viewport.is()) >= app.viewport.getIndex(size),
    isSmallerThan: size => app.viewport.getIndex(app.viewport.is()) < app.viewport.getIndex(size),
    getIndex: size => {
        const number = app.viewport.sizes.indexOf(size);
        if (number === -1) throw 'no valid viewport name given';
        return number;
    }
};

export default app;
